//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
//  -- Actions ------------------------
import * as UserClassActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { handleGetClass  } from "store/classes/thunks"
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create user class --------------
export const handleCreateUserClass = (data) => async(dispatch) => {
    await dispatch(UserClassActions.createUserClass());

    try {
         await apis.post('userClassesRDS', `/userClasses`, {
            body: { ...data }
        });
        // if(hasUpdate){
        //     await dispatch(UserClassActions.createUserClassSuccess(userclass));
        // }
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'creating user class',
                error,
                module: 'USER_CLASSES',
                operation: 'CREATE_USER_CLASS'
            });
         }
        await dispatch(UserClassActions.createUserClassFail(error));
    }
};



//  -- List class users ---------------
export const handleListClassUsers = (classID) => async(dispatch) => {
    if(!classID) return;
    await dispatch(UserClassActions.listClassUsers());

    try {
        let  filteredUsersRDS =[];
        const userclasss = await apis.get('userClassesRDS', `/usersByClass/${classID}`);
        if(Array.isArray(userclasss)){
            filteredUsersRDS = userclasss.filter(x => x.ucId != undefined);
        }
        await dispatch(UserClassActions.listClassUsersSuccess(filteredUsersRDS));
        return filteredUsersRDS;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing class users',
                error,
                module: 'USER_CLASSES',
                operation: 'LIST_CLASS_USER'
            });
         }
        await dispatch(UserClassActions.listClassUsersFail(error));
    }
};
export const handleHideShowClasses = (userId,classID, status) => async (dispatch) => {
    if (!classID) return;

    try {
        const userclasssStatus = await apis.post('classesRDS', `/archivehandller`, {
            body: {
                id: classID,
                status: status
            }
        });
        await dispatch(handleListUserClasses(userId));
        return userclasssStatus;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'hiding/showing classes',
                error,
                module: 'USER_CLASSES',
                operation: 'HANDLE_CLASS'
            });
        }
        return error;
    }
}
export const handleHideShowClassBooks = (userClassId,archived_group,classId) => async (dispatch) => {
    try {
        const userclasssStatus = await apis.post('userClassesRDS', `/updateArchiveBooks`, {
            body: {
                id:userClassId,
                archived_group
            }
        });
        await dispatch(handleGetClass(classId));
        return userclasssStatus;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'hiding/showing class books',
                error,
                module: 'USER_CLASSES',
                operation: 'HANDLE_CLASS_BOOK'
            });
        }
        return error;
    }
}

export const handleHideOrShowParticularClassBooks = (payload,classId) => async (dispatch) => {
    try {
        const userclasssStatus = await apis.post('userClassesRDS', `/updateHideShowBooks`, {
            body:payload
        });
        await dispatch(handleGetClass(classId));
        return userclasssStatus;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'hiding/showing particular class books',
                error,
                module: 'USER_CLASSES',
                operation: 'HANDLE_PLACEMENT_CLASS_BOOK'
            });
        }
        return error;
    }
}
export const handleListUserByClassForTeacher = (teacherId) => async(dispatch) => {
    if(!teacherId) return;
    await dispatch(UserClassActions.listClassUsers());

    try {
        const studentsByClass = await apis.get('userClassesRDS', `/usersByteacher/${teacherId}`);
        if(studentsByClass){
            await dispatch(UserClassActions.setUsersByClass(studentsByClass));
        }
        return studentsByClass;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing user by class for teacher',
                error,
                module: 'USER_CLASSES',
                operation: 'LIST_USER_BOOK_CLASS_FEEDBACK_TIPS'
            });
         }
    }
};

//  -- List user classes --------------
export const handleListUserClasses = (userID) => async(dispatch) => {
    await dispatch(UserClassActions.listUserClasses());

    try {
        let userClass=[]
        const userClassesRDS= await apis.get('userClassesRDS', `/listUserClasses/${userID}`);
        if(Array.isArray(userClassesRDS)){
            userClass = userClassesRDS
        }
        await dispatch(UserClassActions.listUserClassesSuccess(userClass));
        return userClass;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing user classes',
                error,
                module: 'USER_CLASSES',
                operation: 'LIST_USER_CLASS'
            });
         }
        await dispatch(UserClassActions.listUserClassesFail(error));
        return []
    }
};
export const handleRemoveUserClasses = (ucId) => async (dispatch) => {
    await dispatch(UserClassActions.listUserClasses());

    try {

        const userClassesRDS = await apis.del('userClassesRDS', `/userClasses/${ucId}`);
        if (userClassesRDS && userClassesRDS.id) {
            await dispatch(UserClassActions.deleteUserClassSuccess(userClassesRDS));
        }
        return userClassesRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing user classes',
                error,
                module: 'USER_CLASSES',
                operation: 'LIST_USER_CLASS'
            });
        }
        return null;
    }
};

export const getClassUsers =  async(classId) => {
    try {
        let userClass=[]
        const userClassesRDS=  await apis.get('userClassesRDS', `/usersByClass/${classId}`)
        if(Array.isArray(userClassesRDS)){
            userClass = userClassesRDS
        }
        return userClass;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'getting class users',
                error,
                module: 'USER_CLASSES',
                operation: 'GET_CLASS_USER'
            });
         }
        return []
    }
}


export const handleCreateOrUpdateClassConfig = (data) =>async(dispatch) => {
    try {
     const config =    await apis.post('userClassesRDS', `/createOrUpdateClassConfig`, {
            body:data
        });
        if(config&&config.classId){
            dispatch(UserClassActions.updateClassConfig(config))
        }

    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'creating or updating class config',
                error,
                module: 'USER_CLASSES',
                operation: 'CREATE_ORGANIZATION_USER_CLASS_CLASS'
            });
         }
    }
};



export const handleUpdateClasseOrder = (data) => async(dispatch) => {
    try {
        await apis.post('userClassesRDS', `/updateOrder`, {
            body: data
        });
      await dispatch(UserClassActions.updateUserClassesOrder(data));
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'updating class order',
                error,
                module: 'USER_CLASSES',
                operation: 'UPDATE_CLASS_ORGANIZATION'
            });
         }
    }
};

export const handleUpdateClassConfigMeta = (data) => async(dispatch) => {
    try {
        const config = await apis.post('userClassesRDS', `/updateClassConfigMeta`, {
            body: data
        });
        return config;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'updating class config meta',
                error,
                module: 'USER_CLASSES',
                operation: 'UPDATE_CLASS_CONFIG_META'
            });
         }
    }
};
